import debug from 'debug';
import ComponentStorage from 'Global/Shared/Components/ComponentStorage/ComponentStorage';
import { queryString } from 'Global/Shared/Components/QueryString/QueryString';

const log = debug('FrontPageCatalogs:Data:Categories');

class Categories {
	static all;
	static hasSelectedCategories = false;

	static set(categories) {
		const componentStorage = new ComponentStorage({ componentKey: 'CustomerCatalogs' });
		let selectedCategories = queryString.Get('id');

		if (selectedCategories === undefined) {
			selectedCategories = componentStorage.getItem('categories');
		}

		if (selectedCategories === null) {
			Categories.all = categories;
			return;
		}

		this.setSelectedProperty(categories, selectedCategories);
	}

	static setSelectedProperty(categories, selectedCategories) {
		const selectedCategoryIds = selectedCategories.split('|');

		categories.map((category, index) => {
			if (selectedCategoryIds.indexOf(category.id) > -1) {
				categories[index].isSelected = true;
				Categories.hasSelectedCategories = true;
			} else {
				categories[index].isSelected = false;
			}
		});

		Categories.all = categories;
	}
}

export default Categories;
